import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3ddf7b5e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "UserLoginBlue"
};
var _hoisted_2 = {
  key: 0,
  "class": "message__holder"
};
var _hoisted_3 = {
  "class": "message"
};
var _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div style=\"max-width:100vw;pointer-events:none;position:absolute;top:0px;left:0px;\" data-v-3ddf7b5e><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100vw\" height=\"auto\" viewBox=\"0 0 413 68\" fill=\"none\" data-v-3ddf7b5e><path d=\"M264.485 27.6455C354.892 20.6062 389.665 32.6292 413 44.5L413 -0.00012207L0 -0.000120029L0 65C95.007 77.9608 151.477 36.4445 264.485 27.6455Z\" fill=\"white\" fill-opacity=\"0.08\" data-v-3ddf7b5e></path></svg></div><div style=\"position:absolute;top:18px;\" data-v-3ddf7b5e><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"56\" height=\"56\" viewBox=\"0 0 56 56\" fill=\"none\" data-v-3ddf7b5e><g filter=\"url(#filter0_d_22_948)\" data-v-3ddf7b5e><path d=\"M28 0C14.7419 0 4 10.7419 4 24C4 37.2581 14.7419 48 28 48C41.2581 48 52 37.2581 52 24C52 10.7419 41.2581 0 28 0ZM28 9.29032C32.7032 9.29032 36.5161 13.1032 36.5161 17.8065C36.5161 22.5097 32.7032 26.3226 28 26.3226C23.2968 26.3226 19.4839 22.5097 19.4839 17.8065C19.4839 13.1032 23.2968 9.29032 28 9.29032ZM28 42.5806C22.3194 42.5806 17.229 40.0065 13.8226 35.9806C15.6419 32.5548 19.2032 30.1935 23.3548 30.1935C23.5871 30.1935 23.8194 30.2323 24.0419 30.3C25.3 30.7065 26.6161 30.9677 28 30.9677C29.3839 30.9677 30.7097 30.7065 31.9581 30.3C32.1806 30.2323 32.4129 30.1935 32.6452 30.1935C36.7968 30.1935 40.3581 32.5548 42.1774 35.9806C38.771 40.0065 33.6806 42.5806 28 42.5806Z\" fill=\"white\" data-v-3ddf7b5e></path></g><defs data-v-3ddf7b5e><filter id=\"filter0_d_22_948\" x=\"0\" y=\"0\" width=\"56\" height=\"56\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" data-v-3ddf7b5e><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-3ddf7b5e></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" data-v-3ddf7b5e></feColorMatrix><feOffset dy=\"4\" data-v-3ddf7b5e></feOffset><feGaussianBlur stdDeviation=\"2\" data-v-3ddf7b5e></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\" data-v-3ddf7b5e></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" data-v-3ddf7b5e></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_22_948\" data-v-3ddf7b5e></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_22_948\" result=\"shape\" data-v-3ddf7b5e></feBlend></filter></defs></svg></div><div style=\"color:#FFF;text-align:center;text-shadow:7px -2px 4px rgba(0, 0, 0, 0.25);font-family:&#39;Nunito Sans&#39;;font-size:32px;font-style:normal;font-weight:700;margin-top:76px;line-height:27px;\" data-v-3ddf7b5e> Log In </div><div style=\"border-radius:17px;border:1px solid rgba(255, 255, 255, 0.46);background:rgba(255, 255, 255, 0.26);box-shadow:7px 5px 10.7px 0px rgba(0, 0, 0, 0.25);text-align:center;text-shadow:0px 4px 4px rgba(0, 0, 0, 0.25);color:#000;width:395px;height:46px;flex-shrink:0;font-family:Nunito Sans, sans-serif !important;font-size:24px;font-style:normal;font-weight:300;margin-top:15px;padding-top:6px;line-height:normal;\" data-v-3ddf7b5e> Welcome Back! </div>", 4);
var _hoisted_8 = {
  style: {
    "display": "flex",
    "justify-content": "start",
    "margin-top": "20px",
    "width": "100%",
    "max-width": "391px"
  }
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "max-width": "200px",
      "text-align": "right",
      "color": "#FFF",
      "font-family": "'Nunito Sans'",
      "font-size": "14px",
      "font-style": "normal",
      "font-weight": "700",
      "line-height": "normal",
      "flex": "1",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, " Don't Have an Account Yet? ", -1);
});
var _hoisted_10 = {
  style: {
    "width": "40%",
    "align-items": "center"
  }
};
var _hoisted_11 = {
  style: {
    "border-radius": "25px",
    "width": "378px",
    "background": "rgba(255, 255, 255, 0.88)",
    "box-shadow": "3px 14px 8.9px 0px rgba(0, 0, 0, 0.25)",
    "min-height": "415px",
    "flex-shrink": "0",
    "margin": "0 auto",
    "margin-top": "20px"
  }
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#000",
      "text-align": "right",
      "font-family": "'Nunito Sans'",
      "font-size": "16px",
      "margin-right": "20px",
      "font-weight": "300",
      "margin-top": "10px",
      "font-style": "normal",
      "line-height": "normal"
    }
  }, "Log Into Your Account", -1);
});
var _hoisted_13 = {
  "class": "input__container"
};
var _hoisted_14 = {
  "class": "input__container"
};
var _hoisted_15 = ["type"];
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "black"
  }, [/*#__PURE__*/_createTextVNode("By registering, you agree to our "), /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.aivitar.com/terms-and-conditions",
    target: "_system"
  }, "Terms of Service.")], -1);
});
var _hoisted_17 = {
  "class": "bottomItems"
};
var _hoisted_18 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.message.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($data.message), 1)])) : _createCommentVNode("", true), _hoisted_4, _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
    "class": "button button--secondary",
    style: {
      "padding-top": "0px"
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$store.commit('updateShowUserLoginBlue', false);
    })
  }, " Register Now! ")])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("input", {
    "class": "formInput",
    type: "email",
    autocomplete: "email",
    autocapitalize: "on",
    placeholder: "Email Address",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.email = $event;
    })
  }, null, 512), [[_vModelText, $data.email]]), $data.email.length < 3 || $data.emailError ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": _normalizeClass({
      'input__description': true,
      'required': $data.emailError
    })
  }, _toDisplayString($data.emailError ? $data.emailError : '* Required'), 3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [_withDirectives(_createElementVNode("input", {
    onKeyup: _cache[2] || (_cache[2] = _withKeys(function () {
      return $options.userLogin && $options.userLogin.apply($options, arguments);
    }, ["enter"])),
    name: "password-login",
    "class": "formInput passwordInput",
    type: $data.showPassword === true ? 'text' : 'password',
    placeholder: "Password",
    autocomplete: "current-password",
    id: "current-password",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.password = $event;
    })
  }, null, 40, _hoisted_15), [[_vModelDynamic, $data.password]]), $data.showPassword ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 0,
    style: {
      "float": "right",
      "z-index": "1000000000"
    },
    icon: ['fa', 'eye'],
    "class": "eye fa fa-eye",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return $data.showPassword = false;
    }),
    "&&": "",
    "password.length": ""
  })) : _createCommentVNode("", true), !$data.showPassword && $data.password.length ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 1,
    style: {
      "float": "right",
      "z-index": "1000000000"
    },
    "class": "eye fa fa-eye",
    icon: ['fa', 'eye-slash'],
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return $data.showPassword = true;
    })
  })) : _createCommentVNode("", true), $data.password.length < 3 || $data.passwordError ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    "class": _normalizeClass({
      'input__description': true,
      'required': $data.passwordError
    })
  }, _toDisplayString($data.passwordError ? $data.passwordError : '* Required'), 3)) : _createCommentVNode("", true)]), _hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _mergeProps({
    id: "login-button",
    "class": "formButton button",
    style: {
      "margin-top": "30px"
    },
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return $options.userLogin();
    }),
    disabled: $data.password.length < 8 || $data.email.length < 4 || $data.lastname.length < 1 || $data.firstname.length < 1
  }, null), " Sign In ", 16, _hoisted_18)])])]);
}